module.exports = __webpack_public_path__ + "static/media/w2w.c3e8e935.png";